var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{attrs:{"id":"riskFourColor"}},[(_vm.data)?_c('el-image',{staticStyle:{"height":"100%"},attrs:{"src":_vm.imgUrl+_vm.data,"fit":"cover"}}):_c('img',{staticStyle:{"width":"8.5rem","height":"7.9375rem"},attrs:{"src":require("../../common/img/nothing.png"),"alt":""}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731ca411","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/centerTop/index.vue
// module id = null
// module chunks = 